/**
 * Pool campaigns table
 *
 * The campaigns linked to a pool, with each campaign's own share of the matched total.
 */

import React from 'react';
import { Button, Table } from 'semantic-ui-react';
import { I18n, Translate } from 'react-redux-i18n';
import CurrencyHelper from '../../../../helpers/currencyHelper';
import { i18nKeys } from '../constants';
import { PoolCampaign } from '../types';

interface PoolCampaignsTableProps {
  campaigns: PoolCampaign[];
  onRemove: (campaign: PoolCampaign) => void;
}

const PoolCampaignsTable: React.FC<PoolCampaignsTableProps> = ({
  campaigns,
  onRemove
}) => {
  const isLastCampaign = campaigns.length <= 1;
  return (
    <>
      <Table celled compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <Translate value={i18nKeys.CAMPAIGNS.CAMPAIGN} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Translate value={i18nKeys.CAMPAIGNS.ORGANISATION} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Translate value={i18nKeys.CAMPAIGNS.CURRENCY} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Translate value={i18nKeys.CAMPAIGNS.MATCHED} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Translate value={i18nKeys.CAMPAIGNS.ACTIONS} />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {campaigns.map((campaign) => (
            <Table.Row key={campaign.giftMatchingId}>
              <Table.Cell>
                {campaign.campaignName} ({campaign.campaignId})
              </Table.Cell>
              <Table.Cell>{campaign.organizationName}</Table.Cell>
              <Table.Cell>{campaign.currency}</Table.Cell>
              <Table.Cell>
                {I18n.t(i18nKeys.LIST.MATCHED_VALUE, {
                  amount: CurrencyHelper.formatCurrency(
                    campaign.donationMatchedTotalAmount,
                    campaign.currency
                  ),
                  count: campaign.donationMatchedCount
                })}
              </Table.Cell>
              <Table.Cell>
                <Button
                  basic
                  negative
                  size="tiny"
                  type="button"
                  disabled={isLastCampaign}
                  aria-label={`${I18n.t(i18nKeys.CAMPAIGNS.REMOVE)} ${campaign.campaignName ?? campaign.campaignId}`}
                  onClick={() => onRemove(campaign)}
                >
                  <Translate value={i18nKeys.CAMPAIGNS.REMOVE} />
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      {isLastCampaign && (
        <p className="field-description">
          <Translate value={i18nKeys.EDIT.LAST_CAMPAIGN} />
        </p>
      )}
    </>
  );
};

export default PoolCampaignsTable;
